
import cookie from 'Libs/cookie/cookie';

export default {

	preset: window.FMV_PRESET || {},
	config: {
		size: {
			s: 640,
			m: 768,
			l: 1280,
			xl: 1440,
			nav: 'm'
		}
	},
	state: {
		isInIframe: top !== self,
		acceptedCookiesFunctional: cookie.get('FMV_accepted_cookies_functional') === '1',
		acceptedCookiesStatistics: cookie.get('FMV_accepted_cookies_statistics') === '1',
		consentExecuted: cookie.get('FMV_consent_executed') === '1'
	}

};